import { logger } from 'common/services';
import type Keycloak from 'keycloak-js';

const MIN_VALIDITY = 60;

export const updateKeycloakToken = async (keycloak: Keycloak) => {
  try {
    await keycloak.updateToken(MIN_VALIDITY);
  } catch (error) {
    if (error instanceof Error) {
      logger.error('[KC] Failed to refresh the token, or the session has expired', error);
    }
    await keycloak.logout();
  }
};
